/* p-try/index */ function _(require, module, exports) {
    module.exports = (callback, ...args) => new Promise(resolve => {
        resolve(callback(...args));
    });
}
